import React from 'react';

// Colour lookup for the traffic-light status system, matching tokens.css.
const STATUS_COLOURS = {
    todo: {stroke: '#E5484D', bg: '#FDECEC', text: '#B42318', dark: '#FF8B8E', darkBg: '#3A1C1E'},
    doing: {stroke: '#F5A524', bg: '#FEF4DE', text: '#A15C07', dark: '#FBC96B', darkBg: '#3A2E14'},
    done: {stroke: '#30A46C', bg: '#E4F5EB', text: '#18794E', dark: '#6FD49C', darkBg: '#123023'},
};

/**
 * A single status oval used inside the illustration SVGs: a tinted ellipse
 * with a coloured stroke and 600-weight label, per the "Signature details"
 * spec. Renders an <g>, so it must be used inside an <svg>.
 */
const StatusOval = ({
    cx, cy, rx = 72, ry = 26,
    status = 'done',
    label,
    variant = 'solid', // 'solid' | 'outline' | 'dark'
    fontSize = 14,
    strokeWidth = 2.5,
}) => {
    const c = STATUS_COLOURS[status];
    const fill = variant === 'outline' ? 'none' : (variant === 'dark' ? c.darkBg : c.bg);
    const textFill = variant === 'dark' ? c.dark : c.text;

    return (
        <g fontSize={fontSize} fontWeight="600" textAnchor="middle">
            <ellipse cx={cx} cy={cy} rx={rx} ry={ry} fill={fill} stroke={c.stroke} strokeWidth={strokeWidth}/>
            {label && <text x={cx} y={cy + fontSize * 0.35} fill={textFill}>{label}</text>}
        </g>
    );
};

export default StatusOval;
